<template>
  <section class="you-and-me-legend__block">
    <div class="you-and-me-legend__title" :class="mapLayout">
      <TxContent :content="topText"></TxContent>
    </div>
    <div class="you-and-me-legend__subtitle">
      <TxContent :content="bottomText"></TxContent>
    </div>
  </section>
</template>

<script>
import YouAndMeTextModule from "../store-mixin";

export default {
  name: 'YouAndMeTextTitle',
  mixins: [YouAndMeTextModule()],
  computed: {
    topText(){
      return `${this.firstName} & ${this.secondName}`
    },
    bottomText(){
      return `${this.subtitle} - ${this.date}`
    }
  }
}
</script>

<style scoped lang="scss">
@import url('https://fonts.googleapis.com/css?family=Montserrat:300,500,700&display=swap');

.you-and-me-legend {


  &__block {
    background: linear-gradient(to bottom, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.6) 15%, rgba(255, 255, 255, 1) 35%, rgba(255, 255, 255, 1) 100%);
    text-align: center;
    padding-top: 50px;
    position: absolute;
    bottom: -5px;
    left: -2px;
    right: -2px;
    z-index: 999;
    ::v-deep .emoji {
      height: 40px !important;
      width: 40px !important;
      vertical-align: middle !important;
    }
  }

  &__title {
    color: #292929;
    font-size: 61px;
    font-weight: normal;
    font-family: 'Didot', sans-serif;
    letter-spacing: 0;
    line-height: 80px;
    margin-bottom: -5px;
    word-spacing: -8px;

    &.vertical {

    }

    &.horizontal {

    }


    &--img {
      height: 40px;
      width: 40px;
      vertical-align: middle !important;
    }
  }

  &__subtitle {
    font-family: 'Bodoni-72', sans-serif;
    font-size: 29px;
    color: #292929;
    line-height: 60px;
    letter-spacing: 1px;
    word-spacing: -1px;

  }

  &__separator {
    position: relative;
    padding: 0;


    .coords-label {
      position: relative;
      display: inline-block;

      .coords-text {
        font-family: 'Montserrat', sans-serif;
        font-size: 24px;
        display: inline-block;
        z-index: 1;
        background: white;
        padding: 5px 30px;
      }

      .coords-line {
        content: ' ';
        display: block;
        border-top: 3px solid #292929;
        width: 120%;
        left: -10%;
        position: absolute;
        top: calc(50% - 2px);
        z-index: -1;
      }
    }
  }
}

</style>

